import {
  LOGO_URL,
  SISTER_BRAND_URL,
  STUDIO_PARTNER_URL,
  BUILDER_PARTNER_URL,
  CONTACT_EMAIL,
  SERVICE_AREA,
} from "@/lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[hsl(var(--brown))] text-[hsl(var(--cream))]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Heritage Table Catering"
              className="h-14 w-14 object-contain bg-[hsl(var(--cream))] rounded-full p-1"
            />
            <div>
              <div className="font-serif-display text-2xl">Heritage Table</div>
              <div className="text-[10px] tracking-[0.32em] text-[hsl(var(--rose)/0.9)] font-semibold">
                CATERING
              </div>
            </div>
          </div>
          <p className="mt-5 font-script text-2xl text-[hsl(var(--rose)/0.95)]">
            Traditional flavors. Honest food. Beautifully served.
          </p>
          <p className="mt-4 text-sm text-[hsl(var(--cream)/0.8)] max-w-md">
            Multicultural catering, homestyle meals, and handcrafted desserts
            for families, churches, weddings, and gatherings — we serve{" "}
            {SERVICE_AREA}.
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-email-link"
            className="mt-4 inline-block text-sm font-semibold text-[hsl(var(--rose)/0.95)] hover:text-[hsl(var(--cream))] transition-colors"
          >
            {CONTACT_EMAIL}
          </a>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs tracking-[0.24em] uppercase text-[hsl(var(--rose)/0.9)] font-semibold">
            Explore
          </div>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a href="#traditions" className="hover:text-[hsl(var(--rose))]">
                Culinary Traditions
              </a>
            </li>
            <li>
              <a href="#events" className="hover:text-[hsl(var(--rose))]">
                Events We Cater
              </a>
            </li>
            <li>
              <a href="#desserts" className="hover:text-[hsl(var(--rose))]">
                Desserts & Cakes
              </a>
            </li>
            <li>
              <a href="#about" className="hover:text-[hsl(var(--rose))]">
                About
              </a>
            </li>
            <li>
              <a href="#faq" className="hover:text-[hsl(var(--rose))]">
                FAQ
              </a>
            </li>
            <li>
              <a href="#quote" className="hover:text-[hsl(var(--rose))]">
                Request a Quote
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs tracking-[0.24em] uppercase text-[hsl(var(--rose)/0.9)] font-semibold">
            Partners
          </div>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a
                href={SISTER_BRAND_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[hsl(var(--rose))]"
                data-testid="footer-sister-link"
              >
                <span className="block font-semibold">
                  Central Florida Custom Cakes
                </span>
                <span className="block text-xs text-[hsl(var(--cream)/0.7)]">
                  Sister brand — desserts & custom cakes
                </span>
              </a>
            </li>
            <li>
              <a
                href={STUDIO_PARTNER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[hsl(var(--rose))]"
                data-testid="footer-studio-link"
              >
                <span className="block font-semibold">Garcés Bros Studios</span>
                <span className="block text-xs text-[hsl(var(--cream)/0.7)]">
                  Studio partner
                </span>
              </a>
            </li>
            <li>
              <a
                href={BUILDER_PARTNER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[hsl(var(--rose))]"
                data-testid="footer-builder-link"
              >
                <span className="block font-semibold">
                  Build Your Source Code
                </span>
                <span className="block text-xs text-[hsl(var(--cream)/0.7)]">
                  Website partner
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[hsl(var(--cream)/0.15)]">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[hsl(var(--cream)/0.7)]">
          <div>
            © {new Date().getFullYear()} Heritage Table Catering. Serving{" "}
            {SERVICE_AREA}.
          </div>
          <div>Made with care · Crafted to gather.</div>
        </div>
      </div>
    </footer>
  );
}
